module.exports = __webpack_public_path__ + "img/banner-web-2.84f231fe.jpg";